import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'Orgon';
        font-weight: 300;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/orgon/Orgon-LigWeb.woff');
    }
    
    @font-face {
        font-family: 'Orgon';
        font-weight: 400;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/orgon/Orgon-RegWeb.woff');
    }

    @font-face {
        font-family: 'Orgon';
        font-weight: 500;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/orgon/Orgon-MedWeb.woff');
    }

    @font-face {
        font-family: 'Orgon';
        font-weight: 700;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/orgon/Orgon-BolWeb.woff');
    }


    * {
        box-sizing: border-box;
    }

    html, body, #root {
        height: 100%;
    }

    html {
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
    }

    body {
        font-family: 'Orgon', sans-serif;
        margin: 0;
        padding: 0;
    }  

    button, input {
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
    }

    p, h1, h2, h3, h4 {
        margin: 0;
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    a {
        text-decoration: none;
        color: #000;
    }
`;
